export const countdownBannerTypes = {
    DiscountedYearbookRemaining: 'YB_DYR',
    YearbookInventory: 'YB_INV',
    CurrentYearbookSale: 'YB_CYS',
    SpecialClassRingOffer:'JLRY_SCRO',
    YearbookRecAdSale:'YB_YRAS',
} 
export const countdownBannerMap = [
    [countdownBannerTypes.DiscountedYearbookRemaining, countdownBannerTypes.YearbookInventory, countdownBannerTypes.CurrentYearbookSale],
    [countdownBannerTypes.SpecialClassRingOffer],
    [countdownBannerTypes.YearbookRecAdSale]
]

export const countdownBannerLabels = {
    counterText: {
        [countdownBannerTypes.DiscountedYearbookRemaining]: {last: '', singular: 'last book', plural: 'books remaining'},
        [countdownBannerTypes.YearbookInventory]:           {last: '', singular: 'last book', plural: 'books remaining'},
        [countdownBannerTypes.CurrentYearbookSale]:         {last: 'last day', singular: 'day left', plural: 'days left'},
        [countdownBannerTypes.SpecialClassRingOffer]:       {last: 'last day', singular: 'day left', plural: 'days left'},
        [countdownBannerTypes.YearbookRecAdSale]:           {last: 'last day', singular: 'day left', plural: 'days left'},
    },
    actionPrompt: {
        [countdownBannerTypes.DiscountedYearbookRemaining]: 'Hurry! Act Now!',
        [countdownBannerTypes.YearbookInventory]: 'Limited Supply!',
        [countdownBannerTypes.CurrentYearbookSale]: 'Hurry! Act Now!',
        [countdownBannerTypes.SpecialClassRingOffer]: "Don't Miss Out",
        [countdownBannerTypes.YearbookRecAdSale]: 'Act Fast!',
    },
    displayName: {
        [countdownBannerTypes.DiscountedYearbookRemaining]: 'Discounted Yearbooks Remaining',
        [countdownBannerTypes.YearbookInventory]: 'Order Today',
        [countdownBannerTypes.CurrentYearbookSale]: 'Current Yearbook Sale',
        [countdownBannerTypes.SpecialClassRingOffer]: 'Special Class Ring Offer',
        [countdownBannerTypes.YearbookRecAdSale]: 'Yearbook Recognition Ad Sale',
    }
}

export const countdownBannerMockData = {
    '3157073': [
        // {
        //     "counterNumber": 5,
        //     "type": 'YB_DYR',
        //     "catalogOsr": 'SHOP_YEARBOOK_CUSTOMER_CATALOG'
        // },
        {
            "counterNumber": 7,
            "type": 'YB_INV',
            "catalogOsr": 'SHOP_YEARBOOK_CUSTOMER_CATALOG'
        },
        {
            "counterNumber": 10,
            "type": 'YB_CYS',
            "catalogOsr": 'SHOP_YEARBOOK_CUSTOMER_CATALOG'
        },
        {
            "counterNumber": 15,
            "type": 'JLRY_SCRO',
            "catalogOsr": 'SHOP_CLASS_RING_CUSTOMER_CATALOG'
        },
        {
            "counterNumber": 20,
            "type": 'YB_YRAS',
            "catalogOsr": 'SHOP_YEARBOOK_CUSTOMER_CATALOG'
        },
        
    ],
    '2419755': [
        {
            "counterNumber": 20,
            "type": 'YB_YRAS',
            "catalogOsr": 'SHOP_REC-A'
        },
    ],
}